import React from 'react'
import { DashboarCarddWrapper } from './style'
import CheckboxIcon2 from '../../images/CheckboxIcon2';

function DashboardCard2({
  number = "",
  heading = "",
  desc = "",
  img = null,
  complate = false,
  key,
  onClick = () => { },
  disable,
}) {
  const cardClass = complate ? "completed" : disable ? "disabled" : "current";
  return (
    <DashboarCarddWrapper
      key={key}
      onClick={disable ? () => { } : onClick}
      className={`transition-all duration-300 group cursor-pointer ${cardClass}`}
    >
      <div
        className={`group-hover:bg-[#7BC4E0] transition-all duration-300 icons ${complate ? "active" : ""}`}
      >
        <img src={img} alt="icon" />
      </div>
      <div className="rightBox">
        <div className="header flex justify-between">
          <h2 className="group-hover:text-[#7BC4E0] transition-all duration-300">
            {heading}
          </h2>
          <CheckboxIcon2
            color={complate ? "#7BC4E0" : "#575c63"}
            number={number}
          />
        </div>
        <p className={`mt-2 max-w-[250px] transition-all duration-300 ${complate ? "text-gray-600" : disable ? "text-gray-600" : "text-gray-600 group-hover:text-white"}`}>
          {desc}
        </p>
      </div>
    </DashboarCarddWrapper>
  );
}

export default DashboardCard2;